import React, {FC} from 'react'
import {RegisterButton} from 'features/buttons'
import {Hot, Verified} from 'shared/ui/icons'
import {ImageSliderPreview} from 'shared/ui/imageSliderPreview'
import girl1 from 'shared/ui/img/girl1.png'
import styles from './styles.module.scss'

export type UserCardPreviewProps = {
  containerStyles?: React.CSSProperties,
  isOnline?: boolean,
  isVerified?: boolean,
  isHot?: boolean,
  className?: string,
  sliderClassName?: string,
  name: string,
  age: number,
  description?: string,
  images?: string[]
}

export const UserCardPreview: FC<UserCardPreviewProps> = ({
  containerStyles,
  isOnline,
  isVerified,
  isHot,
  className,
  sliderClassName,
  name,
  age,
  description,
  images
}) => {
  return (
    <div className={`${styles.container} ${className}`} style={containerStyles}>
      <ImageSliderPreview className={sliderClassName} images={images || [girl1]} />
      <div className={styles.textContainer}>
        <div className={styles.titleWrapper}>
          {isOnline ? <div className={styles.online} /> : null}
          <p className={styles.name}>{name}, {age}</p>
          {isVerified ? <div className={styles.icon}><Verified /></div> : null}
          {isHot ? <div className={styles.icon}><Hot /></div> : null}
        </div>
        <p className={styles.description}>{description || 'Hello. I\'m looking for a nice man who can make me happy'}</p>
      </div>
      <RegisterButton
        fullwidth
        styleType='primary'
        className={styles.chatNowBtn}
      >
        Chat now
      </RegisterButton>
    </div>
  )
}